import { render, staticRenderFns } from "./main.vue?vue&type=template&id=57b65dbc&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&lang=css&"
import style1 from "./main.vue?vue&type=style&index=1&id=57b65dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../nodejs_workspace/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b65dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/pix/Documents/dev/wedia/wedia/war/nodejs_workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b65dbc')) {
      api.createRecord('57b65dbc', component.options)
    } else {
      api.reload('57b65dbc', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=57b65dbc&scoped=true&", function () {
      api.rerender('57b65dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/javascript/bov3/js/vue/components/wedia/wxm-gallery-card/src/main.vue"
export default component.exports